import { Routes } from '@angular/router';
import { oofRoutes } from './oof.routes';
import { ProfilePageComponent } from './pages/profile-page.component';
import { isAuthenticated } from './shared/guards/keycloak.guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [isAuthenticated],
    children: [
      {
        path: 'orders',
        children: oofRoutes,
      },
      {
        path: 'airtimes',
        title: 'Airtimes',
        loadChildren: () => import('@vectronic/customer-airtimes').then((c) => c.routes),
      },
      {
        path: 'rma',
        title: 'RMA',
        loadComponent: () => import('@vectronic/rma').then((c) => c.RmaListComponent),
        children: [{ path: ':rmaId', title: 'RMA', children: [] }],
      },
      { path: 'profile', component: ProfilePageComponent },
      { path: '', redirectTo: 'orders', pathMatch: 'full' },
      { path: '**', redirectTo: 'orders' },
    ],
  },
];
